import './MapStrip.css';

export default function MapStrip() {
  return (
    <div className="map-strip">
      <div className="map-strip__header">
        <span className="map-strip__icon">📍</span>
        <span className="map-strip__text">
          Notre Showroom — 87 Av. Habib Bourguiba, Ez-Zahra 2034, Tunisie
        </span>
      </div>
      <iframe
        title="Khansa Yazidi Showroom"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3194.5!2d10.3012!3d36.7442!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzbCsDQ0JzM5LjEiTiAxMMKwMTgnMDQuMyJF!5e0!3m2!1sfr!2stn!4v1700000000000"
        width="100%"
        height="280"
        style={{ border: 0, display: 'block' }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}
